import { createSlice } from "@reduxjs/toolkit";

const voucherFonehouseSlice = createSlice({
  name: "voucherFonehouse",
  initialState: {
    isLoading: false,
    docs: [],
    totalDocs: 0,
    totalPages: 1,
    page: 1,
    limit: 10,
    isCreating: false,
    isModalVisible: false,
    modalData: null,
    generatedCode: "",
  },
  reducers: {
    getVoucherListRequest(state) {
      return { ...state, isLoading: true };
    },
    getVoucherListSuccess(state, action) {
      const { payload = {} } = action;
      const { docs = [], totalDocs = 0, totalPages = 1, page = 1 } = payload;
      return {
        ...state,
        isLoading: false,
        docs: docs.map((doc) => ({ ...doc, key: doc._id })),
        totalDocs,
        totalPages,
        page,
      };
    },
    getVoucherListFailure(state) {
      return { ...state, isLoading: false };
    },
    createVoucherRequest: {
      reducer: (state) => ({ ...state, isCreating: true }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createVoucherSuccess: {
      reducer: (state) => ({
        ...state,
        isCreating: false,
        isModalVisible: false,
        modalData: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createVoucherFailure(state) {
      return { ...state, isCreating: false };
    },
    updateVoucherRequest: {
      reducer: (state) => ({ ...state, isCreating: true }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateVoucherSuccess: {
      reducer: (state) => ({
        ...state,
        isCreating: false,
        isModalVisible: false,
        modalData: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateVoucherFailure(state) {
      return { ...state, isCreating: false };
    },
    deleteVoucherRequest(state) {
      return { ...state, isLoading: true };
    },
    deleteVoucherSuccess(state) {
      return { ...state, isLoading: false };
    },
    deleteVoucherFailure(state) {
      return { ...state, isLoading: false };
    },
    generateCodeRequest(state) {
      return { ...state };
    },
    generateCodeSuccess(state, action) {
      return { ...state, generatedCode: action.payload?.code || "" };
    },
    generateCodeFailure(state) {
      return { ...state };
    },
    setVoucherModal(state, action) {
      const { visible, data } = action.payload;
      return {
        ...state,
        isModalVisible: visible,
        modalData: data || null,
      };
    },
    clearGeneratedCode(state) {
      return { ...state, generatedCode: "" };
    },
  },
});

export const {
  getVoucherListRequest,
  getVoucherListSuccess,
  getVoucherListFailure,
  createVoucherRequest,
  createVoucherSuccess,
  createVoucherFailure,
  updateVoucherRequest,
  updateVoucherSuccess,
  updateVoucherFailure,
  deleteVoucherRequest,
  deleteVoucherSuccess,
  deleteVoucherFailure,
  generateCodeRequest,
  generateCodeSuccess,
  generateCodeFailure,
  setVoucherModal,
  clearGeneratedCode,
} = voucherFonehouseSlice.actions;

export default voucherFonehouseSlice.reducer;
